/**
*
* File is used to provide basic functionality for view
*
*/
import {user} from '../../core/controllers/user'

var LoginHelper = Class.create({
    initialize: function() {
        jQuery(document).ready(function(e) { 
            // #  Setup page
            jQuery(".content").css({
                "padding": "0",
                "margin": "0" 
            });
            jQuery('.login-box input').iCheck({
                checkboxClass: 'icheckbox_square-blue',
                radioClass: 'iradio_square-blue',
                increaseArea: '20%' // optional
            });

            var checkbox = jQuery('.icheckbox_square-blue'),
                userField = jQuery('#username'),
                passField = jQuery('#password'),
        
                // assign the key name to a variable
                // so we don't have to type it up every time
                key = 'savedUsername',
                key_two = 'savedPassword',
                // use jStorage to retrieve a stored key
                // on first load this is going to return undefined
                username = jQuery.jStorage.get(key),
                password = jQuery.jStorage.get(key_two);
        
            // if a username was saved from previous session
            // set the value of the username field to that
            // tick off the checkbox and set focus on password field
            if (username) {
                userField.val(username);
                checkbox.addClass('checked');
                jQuery('#password').focus();
            }
        
            // if username wasn't saved then
            // set username field value to blank and focus on it
            // and make sure the checkbox is unchecked
            else {
                userField.val('').focus();
            }
            if (password) {
                passField.val(password);
                jQuery('#password').focus();
                
            }
            // when form is submitted check the checkbox
            // if it's checked then save the username using jStorage
            // if not then delete whatever saved username exists
            jQuery("#login").on('click',function(e){
                if (checkbox.hasClass("checked")) {
                    jQuery.jStorage.set(key, userField.val());
                    jQuery.jStorage.set(key_two, passField.val());
                }
                else {
                    jQuery.jStorage.deleteKey(key);
                    jQuery.jStorage.deleteKey(key_two);
                }
            });
        });
	},
    logUserOn: function(){
        var username = jQuery("#username").val();
        var password = jQuery("#password").val();

        user.logUserOn(username, password, this.handleResults);
    },
    handleResults: function(response){
        if(!response){
            jQuery(".login-box-msg").html('Your username or password is incorrect');
        } else {
            if(response.data.error_user_authentication > 0 && !response.data.message) {
                jQuery(".login-box-msg").html('Your username or password is incorrect');
            } else if(response.data.message) {
                jQuery(".login-box-msg").html(response.data.message);
            } else {
                jQuery(".login-box-msg").html('Something went wrong, try again.');
            }
        }
    }
});

export let loginHelper = new LoginHelper();


// WEBPACK FOOTER //
// app/helpers/Login/index.js